// Mock data for Alf Uniform website

export const mockData = {
  company: {
    name: "Alf Uniform",
    tagline: "Kuwait's #1 Ready-Made Uniform Supplier",
    subTagline: "Corporate & Custom Uniforms with Immediate Availability",
    description: "High-Quality Embroidery & Printing | Ready Stock in All Sizes | Same-Day Delivery Available",
    established: "Since 2017",
    location: "OFFICE 23, FLOOR M1. ALI TOWER MIRQAB QIBLA"
  },
  
  contact: {
    phone: "+965 66902952",
    whatsapp: "+965 66902952",
    email: "alfuniforms@gmail.com",
    website: "www.alfstationery.com",
    instagram: "@alfuniform.kw",
    contactPerson: "Ali Asgar"
  },
  
  services: [
    {
      id: 1,
      title: "Ready Stock Uniforms",
      description: "Immediate availability in all sizes - No waiting time. Get your uniforms today!",
      icon: "PackageCheck",
      featured: true
    },
    {
      id: 2,
      title: "Computer Embroidery",
      description: "High-precision embroidery with state-of-the-art machines for perfect logo reproduction",
      icon: "Sparkles"
    },
    {
      id: 3,
      title: "DTF Printing",
      description: "Direct-to-Film printing technology for vibrant, durable designs on any fabric",
      icon: "Printer"
    },
    {
      id: 4,
      title: "Screen Printing",
      description: "Traditional screen printing for bulk orders with consistent quality and color",
      icon: "Palette"
    },
    {
      id: 5,
      title: "Custom Logo Branding",
      description: "Professional logo design and application services to enhance your brand identity",
      icon: "Award"
    },
    {
      id: 6,
      title: "Same-Day Delivery",
      description: "Express delivery service for in-stock items across Kuwait",
      icon: "Truck"
    }
  ],
  
  industries: [
    {
      id: 1,
      title: "Corporate Offices",
      description: "Professional attire for businesses and corporate environments",
      icon: "Building2"
    },
    {
      id: 2,
      title: "Security Companies",
      description: "Durable uniforms with clear identification for security personnel",
      icon: "Shield"
    },
    {
      id: 3,
      title: "Restaurants & Cafes",
      description: "Stylish and functional uniforms for hospitality staff",
      icon: "Coffee"
    },
    {
      id: 4,
      title: "Hospitals & Clinics",
      description: "Comfortable, hygienic medical scrubs and healthcare uniforms",
      icon: "Heart"
    },
    {
      id: 5,
      title: "Schools",
      description: "Quality school uniforms that stand up to daily wear",
      icon: "GraduationCap"
    },
    {
      id: 6,
      title: "Industrial & Construction",
      description: "Safety-compliant workwear for industrial environments",
      icon: "HardHat"
    }
  ],
  
  bulkOffers: [
    {
      id: 1,
      quantity: "50+ pieces",
      benefit: "Special Price",
      discount: "Competitive rates for medium orders"
    },
    {
      id: 2,
      quantity: "100+ pieces",
      benefit: "Special Price",
      discount: "Better pricing for larger quantities"
    },
    {
      id: 3,
      quantity: "200+ pieces",
      benefit: "Special Price",
      discount: "Best rates for bulk orders"
    }
  ],
  
  whyChooseUs: [
    {
      id: 1,
      title: "Kuwait's Largest Ready Stock",
      description: "Extensive inventory with all sizes available for immediate pickup",
      icon: "Package"
    },
    {
      id: 2,
      title: "No Waiting Time",
      description: "Get your uniforms today - same-day delivery for in-stock items",
      icon: "Zap"
    },
    {
      id: 3,
      title: "Since 2017 Experience",
      description: "Years of expertise in corporate uniform manufacturing",
      icon: "Calendar"
    },
    {
      id: 4,
      title: "In-house Embroidery Machines",
      description: "Advanced equipment for precise and efficient production",
      icon: "Settings"
    },
    {
      id: 5,
      title: "Premium Fabric Quality",
      description: "Only the finest materials for comfortable, long-lasting uniforms",
      icon: "Star"
    },
    {
      id: 6,
      title: "Trusted by Kuwait Businesses",
      description: "Proven track record with leading companies across Kuwait",
      icon: "Users"
    }
  ],
  
  readyStockFeatures: [
    {
      id: 1,
      title: "All Sizes Available",
      sizes: "XS, S, M, L, XL, 2XL, 3XL, 4XL",
      icon: "Ruler"
    },
    {
      id: 2,
      title: "Immediate Pickup",
      description: "Visit our showroom and take your uniforms home today",
      icon: "Store"
    },
    {
      id: 3,
      title: "Same-Day Delivery",
      description: "Order before 2 PM for same-day delivery across Kuwait",
      icon: "Clock"
    },
    {
      id: 4,
      title: "No Minimum Order",
      description: "Buy as few as 1 piece or bulk quantities - we serve all needs",
      icon: "ShoppingCart"
    }
  ],
  
  stockCategories: [
    {
      id: 1,
      name: "Polo Shirts",
      colors: ["White", "Navy Blue", "Black", "Grey"],
      inStock: true
    },
    {
      id: 2,
      name: "Work Pants",
      colors: ["Black", "Navy Blue", "Khaki"],
      inStock: true
    },
    {
      id: 3,
      name: "Chef Uniforms",
      colors: ["White", "Black"],
      inStock: true
    },
    {
      id: 4,
      name: "Medical Scrubs",
      colors: ["Blue", "Green", "White"],
      inStock: true
    },
    {
      id: 5,
      name: "Security Uniforms",
      colors: ["Navy Blue", "Black"],
      inStock: true
    },
    {
      id: 6,
      name: "Aprons",
      colors: ["Black", "White", "Navy"],
      inStock: true
    }
  ],
  
  gallery: [
    {
      id: 1,
      title: "Corporate Uniforms",
      image: "https://images.unsplash.com/photo-1760324457032-cdbf91381531",
      category: "Corporate"
    },
    {
      id: 2,
      title: "Uniform Display",
      image: "https://images.unsplash.com/photo-1766289198971-e53bc0a762c3",
      category: "Retail"
    },
    {
      id: 3,
      title: "Medical Scrubs",
      image: "https://images.pexels.com/photos/4270371/pexels-photo-4270371.jpeg",
      category: "Healthcare"
    },
    {
      id: 4,
      title: "Chef Uniforms",
      image: "https://images.unsplash.com/photo-1759521296047-89338c8e083d",
      category: "Hospitality"
    },
    {
      id: 5,
      title: "Professional Chef",
      image: "https://images.pexels.com/photos/3814446/pexels-photo-3814446.jpeg",
      category: "Hospitality"
    },
    {
      id: 6,
      title: "Service Industry",
      image: "https://images.pexels.com/photos/5778312/pexels-photo-5778312.jpeg",
      category: "Service"
    }
  ],
  
  uniformTypes: [
    "Polo Shirts",
    "Hoodies",
    "Medical Uniforms",
    "Chef Uniforms",
    "Aprons",
    "Security Uniforms",
    "Corporate Shirts",
    "Work Pants",
    "Safety Vests",
    "School Uniforms"
  ],
  
  trustedClients: [
    {
      id: 1,
      name: "Power Wood",
      category: "Furniture & Decoration",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/ip6bl3fv_images%20%282%29.png"
    },
    {
      id: 2,
      name: "Noval Aluminum",
      category: "Aluminum",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/lajyqcc8_images%20%281%29.png"
    },
    {
      id: 3,
      name: "Baico Aluminium Systems",
      category: "Aluminium Systems",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/x14j7t63_images.png"
    },
    {
      id: 4,
      name: "Play",
      category: "Entertainment",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/ugthq0zx_logo-1.png"
    },
    {
      id: 5,
      name: "Mena Casa",
      category: "Hospitality",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/ckcsm694_Mena_Casa-Logo.png"
    },
    {
      id: 6,
      name: "Atyab Al Marshoud",
      category: "Perfumes & Luxury",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/739iaiit_0085943-269-rinnoo-a5083569d4e844bb8bff948b04cba3cb.jpg"
    },
    {
      id: 7,
      name: "KDCow",
      category: "Food & Beverage",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/3ow9u8ek_210737.jpg"
    },
    {
      id: 8,
      name: "Gissah",
      category: "Perfumes & Luxury",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/64v4mofm_o.5151.jpg"
    },
    {
      id: 9,
      name: "Al Farsi Group",
      category: "Conglomerate",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/rf7vy0yc_alfarsi.jpg"
    },
    {
      id: 10,
      name: "GameHex",
      category: "Gaming & Entertainment",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/im844zul_GAMEHEXwhite.webp"
    },
    {
      id: 11,
      name: "Shake Shack",
      category: "Food & Beverage",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/22ls2fbn_images%20%283%29.png"
    },
    {
      id: 12,
      name: "Chippy Fish & Chips",
      category: "Food & Beverage",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/fj36q54z_images%20%284%29.jpg"
    },
    {
      id: 13,
      name: "SVN",
      category: "Fashion",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/x6pklkes_svn%20logo%20-%20jpeg.jpg"
    },
    {
      id: 14,
      name: "Medicals International",
      category: "Healthcare",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/83174d1g_images%20%283%29.jpg"
    },
    {
      id: 15,
      name: "Baitah's",
      category: "Hospitality",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/i5axolsi_LOGO_Talabat04638980277635023480.webp"
    },
    {
      id: 16,
      name: "NAC",
      category: "Corporate",
      logo: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/otyhlrtv_images%20%285%29.jpg"
    }
  ]
};
